// extracted by mini-css-extract-plugin
module.exports = {"customAmount":"GiftCardCustomAmount_customAmount__2kpvv","textField":"GiftCardCustomAmount_textField__KW3_2"};